import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  margin: 0 auto;
  padding: 0 ${props => props.theme?.spacing?.container?.padding || '1.5rem'};
  max-width: ${props => props.theme?.spacing?.container?.maxWidth?.default || '1280px'};
  
  @media (min-width: 1024px) {
    padding: 0 2rem;
    max-width: 1400px;
  }
  
  @media (min-width: 1440px) {
    padding: 0 3rem;
    max-width: 1600px;
  }
  
  @media (min-width: 1920px) {
    padding: 0 4rem;
    max-width: ${props => props.theme?.spacing?.container?.maxWidth?.['2xl'] || '1800px'};
  }
`;


